(function () {
  'use strict';

  function qsa(scope, selector) {
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
  }

  function qs(scope, selector) {
    return scope.querySelector(selector);
  }

  function getFocusable(scope) {
    if (!scope) return [];

    return qsa(
      scope,
      'a[href], button:not([disabled]), input:not([disabled]), summary, select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ).filter(function (element) {
      return element.offsetParent !== null && element.getAttribute('aria-hidden') !== 'true';
    });
  }

  function initOlmoStorefrontHeader(root) {
    var scope = root || document;
    var headers = qsa(scope, '[data-osh-root]');

    headers.forEach(function (header) {
      if (header.dataset.oshInit === 'true') return;
      header.dataset.oshInit = 'true';

      var sectionId = header.getAttribute('data-section-id');
      var triggers = qsa(header, '[data-osh-trigger]');
      var panels = qsa(header, '[data-osh-panel]');
      var activeName = null;
      var closeTimer = null;
      var lastFocusedElement = null;

      panels.forEach(function (panel) {
        if (panel.parentNode !== document.body) {
          document.body.appendChild(panel);
        }

        panel.addEventListener('mouseenter', clearClose);
        panel.addEventListener('mouseleave', scheduleClose);
        panel.addEventListener('focusin', clearClose);
      });

      function getPanel(name) {
        for (var i = 0; i < panels.length; i += 1) {
          if (panels[i].getAttribute('data-osh-panel') === name) {
            return panels[i];
          }
        }

        return null;
      }

      function positionPanels() {
        var rect = header.getBoundingClientRect();
        var top = Math.max(0, Math.round(rect.bottom));

        panels.forEach(function (panel) {
          panel.style.setProperty('--osh-mega-top', top + 'px');
          panel.style.maxHeight = Math.max(280, window.innerHeight - top) + 'px';
        });
      }

      function clearClose() {
        if (!closeTimer) return;

        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      function scheduleClose() {
        clearClose();

        closeTimer = window.setTimeout(function () {
          closeMega();
        }, 180);
      }

      function setTriggerActive(name) {
        triggers.forEach(function (trigger) {
          var isActive = trigger.getAttribute('data-osh-trigger') === name;

          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
      }

      function openMega(name) {
        var panel = getPanel(name);

        if (!panel) return;

        clearClose();
        positionPanels();

        panels.forEach(function (item) {
          var isActive = item === panel;

          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        activeName = name;
        setTriggerActive(name);
      }

      function closeMega() {
        activeName = null;

        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
          panel.setAttribute('aria-hidden', 'true');
        });

        setTriggerActive(null);
      }

      triggers.forEach(function (trigger) {
        var name = trigger.getAttribute('data-osh-trigger');

        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-haspopup', 'true');

        trigger.addEventListener('mouseenter', function () {
          openMega(name);
        });

        trigger.addEventListener('focus', clearClose);

        trigger.addEventListener('mouseleave', scheduleClose);

        trigger.addEventListener('click', function (event) {
          event.preventDefault();

          if (activeName === name && event.detail === 0) {
            closeMega();
          } else {
            openMega(name);
          }
        });
      });

      var drawer = qs(document, '[data-osh-drawer="' + sectionId + '"]');
      var backdrop = qs(document, '[data-osh-backdrop="' + sectionId + '"]');
      var openDrawerButton = qs(header, '[data-osh-open]');
      var closeDrawerButton = drawer ? qs(drawer, '[data-osh-close]') : null;
      var drawerId = 'OshDrawer-' + sectionId;

      function setDrawerState(isOpen) {
        if (!drawer || !backdrop) return;

        drawer.classList.toggle('is-open', isOpen);
        backdrop.classList.toggle('is-open', isOpen);
        drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        document.documentElement.classList.toggle('osh-drawer-open', isOpen);

        if (openDrawerButton) {
          openDrawerButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
      }

      function openDrawer() {
        if (!drawer || !backdrop) return;

        closeMega();
        lastFocusedElement = document.activeElement;
        setDrawerState(true);

        window.requestAnimationFrame(function () {
          var focusable = getFocusable(drawer);

          if (focusable.length > 0) {
            focusable[0].focus();
          }
        });
      }

      function closeDrawer(returnFocus) {
        if (!drawer || !backdrop) return;

        var wasOpen = drawer.classList.contains('is-open');
        setDrawerState(false);

        if (
          returnFocus !== false &&
          wasOpen &&
          lastFocusedElement &&
          typeof lastFocusedElement.focus === 'function'
        ) {
          lastFocusedElement.focus();
        }
      }

      if (drawer) {
        drawer.id = drawer.id || drawerId;
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        drawer.setAttribute('aria-hidden', 'true');

        qsa(drawer, 'a[href]').forEach(function (link) {
          link.addEventListener('click', function () {
            closeDrawer(false);
          });
        });
      }

      if (openDrawerButton) {
        openDrawerButton.setAttribute('aria-controls', drawer ? drawer.id : drawerId);
        openDrawerButton.setAttribute('aria-expanded', 'false');
        openDrawerButton.addEventListener('click', openDrawer);
      }

      if (closeDrawerButton) {
        closeDrawerButton.addEventListener('click', function () {
          closeDrawer(true);
        });
      }

      if (backdrop) {
        backdrop.addEventListener('click', function () {
          closeDrawer(true);
        });
      }

      document.addEventListener('click', function (event) {
        if (!activeName) return;

        var panel = getPanel(activeName);
        var target = event.target;

        if (header.contains(target)) return;
        if (panel && panel.contains(target)) return;

        closeMega();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeMega();
          closeDrawer(true);
          return;
        }

        if (event.key !== 'Tab' || !drawer || !drawer.classList.contains('is-open')) return;

        var focusable = getFocusable(drawer);

        if (focusable.length === 0) {
          event.preventDefault();
          return;
        }

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      window.addEventListener(
        'resize',
        function () {
          positionPanels();

          if (window.innerWidth > 1080) {
            closeDrawer(false);
          }
        },
        { passive: true }
      );
      window.addEventListener('scroll', positionPanels, { passive: true });
      window.addEventListener('load', positionPanels, { once: true });

      window.requestAnimationFrame(positionPanels);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initOlmoStorefrontHeader(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initOlmoStorefrontHeader(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;

    if (!sectionId) return;

    qsa(document, '[data-osh-portal="' + sectionId + '"]').forEach(function (node) {
      node.remove();
    });
  });
})();
